var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50.5,
    r: 50,
    fill: "#172F48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7267 33.1125L30.5131 60.1798C30.1788 60.7587 30.0019 61.415 30 62.0835C29.9981 62.752 30.1713 63.4094 30.5024 63.9901C30.8334 64.5709 31.3108 65.0549 31.8869 65.3939C32.4631 65.7329 33.1179 65.9152 33.7864 65.9225H66.2136C66.8821 65.9152 67.5369 65.7329 68.1131 65.3939C68.6892 65.0549 69.1666 64.5709 69.4976 63.9901C69.8287 63.4094 70.0019 62.752 70 62.0835C69.9981 61.415 69.8212 60.7587 69.4869 60.1798L53.2733 33.1125C52.9321 32.5499 52.4516 32.0847 51.8782 31.7619C51.3049 31.4391 50.658 31.2695 50 31.2695C49.342 31.2695 48.6951 31.4391 48.1218 31.7619C47.5484 32.0847 47.0679 32.5499 46.7267 33.1125Z",
    stroke: "#ACC2DD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 42.9512V53.4795",
    stroke: "#ACC2DD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 58.2656H50.0191",
    stroke: "#ACC2DD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ea866f4db70bd34ab6a19af065e461c2.svg";
export { ForwardRef as ReactComponent };